<template>
    <div class="bid_w_con">
        <span class="bid_title">프로젝트 카테고리를 선택해주세요</span>
        <ul class="bidding_seg_con">
            <li class="bidding_cat_item" :data-title="item.title" @click="toggle_on_popcon_category($event)" v-for="item in category.popcon_category" >
                {{item.title}}
            </li>
        </ul> 
        <div style="clear:both"></div> 
        <span class="bid_title">지역을 선택해주세요</span>
        <ul class="bidding_seg_con">
            <li class="bidding_local_item" :data-title="item.title" @click="toggle_on_local($event)" v-for="item in category.local" >
                {{item.title}}
            </li>
        </ul>   
       
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
    props:["category"],
    data(){
        return {
            detail_category:[]
        }
    },
    methods:{
        toggle_on_popcon_category(e){
            $(".bidding_cat_item").removeClass("on")
            $(e.target).addClass("on")                        
            EventBus.$emit("select_popcon_category",$(e.target).attr("data-title") )
        },
        toggle_on_local(e){
            $(".bidding_local_item").removeClass("on")
            $(e.target).addClass("on")                        
            EventBus.$emit("select_local_category",$(e.target).attr("data-title") )
        },
        prevStep(){EventBus.$emit("bidding_prev")},
        nextStep(){EventBus.$emit("bidding_next")},
    }, 

}
</script>
<style scoped lang="scss">
.bid_w_con{
    padding: 25px 50px;    
    .bid_title{
        font-size: 25px;
        font-weight: bold;
        color: #373737;
        line-height: 1;
        margin-bottom: 15px;
        margin-top: 15px;
        display: inline-block;
    }
    .bidding_seg_con{
        margin-top: 15px;
        border-top: 1px solid #e9e9e9;
        width: 700px;
        margin-left:50px;
        .bidding_cat_item,.bidding_local_item{
            display: list-item;
            color: #454545;
            cursor: pointer;
            width: 50%;
            box-sizing: border-box;
            float: left;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            font-size: 15px;
            text-align: left;       
            height: 55px;
            line-height: 55px;
            padding-left: 30px;
        }
        .bidding_cat_item:hover, .on , .bidding_local_item:hover, {
            background: #f27823;
            color: #fff;
        }
        .bidding_cat_item:nth-child(2n-1) , .bidding_local_item:nth-child(2n-1){
            border-left: 1px solid #e9e9e9;
        }        
    }
      .prev{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: left;
        margin:30px;
        cursor: pointer;
    }
    .next{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: right;
        margin: 30px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/SPA/Components/Bidding/BiddingCategory.vue